import { CheckoutAggregatorStore } from "./checkout/CheckoutAggregatorStore";
import { LazyStore } from "../utils/Store";
// See the same constant in the checkout service
export const CHECKOUT_LIFESPAN_MINUTES = 20;
const DEFAULT_CHECKOUT_DURATION_MS = CHECKOUT_LIFESPAN_MINUTES * 60 * 1000;
export type TimeCounter = {
	minutes: number;
	seconds: number;
};
type TimerStoreStateInternal = {
	timestamp: number | null | undefined;
};
export type TimerStoreState = {
	remainingTime: TimeCounter | null | undefined;
};
export class CheckoutTimerStoreImpl extends LazyStore {
	_checkoutStore: any;
	_state!: TimerStoreStateInternal;
	_intervalId: any;

	constructor(checkoutStore: any) {
		super();
		this._checkoutStore = checkoutStore;
		this.resetState(false);
	}

	onArm = () => {
		this.listenTo(this._checkoutStore, this.handleCheckoutUpdate);
		this.handleCheckoutUpdate();
	};
	onDisarm = () => {
		this.clearTicker();
		this.resetState(false);
	};
	resetState = (propagate = true) => {
		this._state = {
			timestamp: null,
		};

		if (propagate) {
			this.trigger();
		}
	};
	handleCheckoutUpdate = () => {
		const checkoutData = this._checkoutStore.getCheckoutData();

		if ((!checkoutData || checkoutData.status.type !== "IN_PROGRESS") && !!this._state.timestamp) {
			this.clearTicker();
			this.resetState();
			return;
		}

		if (checkoutData && checkoutData.status.type === "IN_PROGRESS" && !this._state.timestamp) {
			this._state = {
				timestamp: checkoutData.status.timestamp,
			};
			this.startTicker();
			this.trigger();
		}
	};
	getRemainingMs = (creationTime: number): number => {
		const now = Date.now();
		return DEFAULT_CHECKOUT_DURATION_MS - (now - creationTime);
	};

	millisecondsToTime(milliseconds: number): TimeCounter {
		if (milliseconds <= 0) {
			return {
				minutes: 0,
				seconds: 0,
			};
		}

		const totalSeconds = Math.ceil(milliseconds / 1000);
		const secondsLeftToFullHour = totalSeconds % (60 * 60);
		const minutes = Math.floor(secondsLeftToFullHour / 60);
		const seconds = secondsLeftToFullHour % 60;
		return {
			minutes,
			seconds,
		};
	}

	startTicker = () => {
		this.clearTicker();
		this._intervalId = setInterval(() => {
			if (!this._state.timestamp || this.getRemainingMs(this._state.timestamp) <= 0) {
				this.clearTicker();
			}

			this.trigger();
		}, 1000);
	};
	clearTicker = () => {
		if (this._intervalId) {
			clearInterval(this._intervalId);
			this._intervalId = null;
		}
	};

	getState(): TimerStoreState {
		const { timestamp } = this._state;

		if (!timestamp) {
			return {
				remainingTime: null,
			};
		}

		const remainingTime = this.millisecondsToTime(this.getRemainingMs(timestamp));
		return {
			remainingTime,
		};
	}
}
export const CheckoutTimerStore = new CheckoutTimerStoreImpl(CheckoutAggregatorStore);
